import {SET_LOADING} from './loadingTypes';

const initialState = {
   open: false
};

function loadingReducer(state = initialState, action) {
   switch (action.type) {
      case SET_LOADING:
         return {...state, open: action.payload};
      default:
         return state;
   }
}

export default loadingReducer;
